import React from "react";
import { Grid } from "@mui/material";
import TrikotCard from "./TrikotCard";

const TrikotGrid = ({ trikots, onBid, isLoggedIn }) => {
  return (
    <Grid
      container
      spacing={3}
      sx={{
        transition: "all 1s ease-in-out",
      }}
    >
      {trikots.map((trikot, index) => (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
	        xl={2}
          key={trikot._id}
          sx={{
            transition: "all 1s ease-in-out",
            position: "relative",
            order: index,
          }}
        >
          <TrikotCard
            trikot={trikot}
            onBid={() => {
              const isExpired = new Date(trikot.endTime) < new Date();
              if (isExpired) {
                return;
              }
              onBid(trikot);
            }}
            isLoggedIn={isLoggedIn}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default TrikotGrid;
